export default __webpack_public_path__ + "static/instagram-d4773a805553164ede232689668e4243.png";